import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./SignUp.css";

const SignUp = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    phone: "",
    licenseKey: "",
    role: "",
    acceptedTerms: false,
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  // Validate fields
  const { fullName, email, password, phone, licenseKey, acceptedTerms } = formData;

  if (!acceptedTerms) {
    setMessage("You must accept the Terms and Privacy Policy.");
    return;
  }

  if (!fullName || !email || !password || !phone || !licenseKey) {
    setMessage("Please fill in all fields.");
    return;
  }

  try {
    const response = await fetch("https://senu-app.azurewebsites.net/api/admins/register", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    fullName,
    email,
    password,
    phone,
    licenseKey,
    role: formData.role, // ✅ fix here
  }),
  
});


    const result = await response.json();
    if (response.ok) {
          setMessage("Submitting role:", formData.role);

      setMessage("✅ Registered successfully!");
      setFormData({
        fullName: "",
        email: "",
        password: "",
        phone: "",
        licenseKey: "",
        role: "",
        acceptedTerms: false,
      });
      
    } else {
      setMessage(`❌ Error: ${result.message || "Registration failed"}`);
    }
  } catch (error) {
    setMessage("❌ Network error: Could not connect to the server");
  }
};


  return (
    <div className="signup-container">
      <h2 className="signup-title">Create Security Admin Account</h2>
      <form className="signup-form" onSubmit={handleSubmit}>
        <input
          name="fullName"
          type="text"
          placeholder="Full Name"
          className="signup-input"
          value={formData.fullName}
          onChange={handleChange}
        />
        <input
          name="email"
          type="email"
          placeholder="Enter Username or Email"
          className="signup-input"
          value={formData.email}
          onChange={handleChange}
        />
        <input
          name="password"
          type="password"
          placeholder="Enter Password"
          className="signup-input"
          value={formData.password}
          onChange={handleChange}
        />
        <input
          name="phone"
          type="text"
          placeholder="Enter Phone Number"
          className="signup-input"
          value={formData.phone}
          onChange={handleChange}
        />
        <select
          name="role"
          value={formData.role}
          onChange={handleChange}
          className="signup-input"
        >
          <option value="">Select Role</option>
          <option value="Station">Station</option>
          <option value="Patrol">Patrol Unit</option>
        </select>

        <input
          name="licenseKey"
          type="text"
          placeholder="License Key"
          className="signup-input"
          value={formData.licenseKey}
          onChange={handleChange}
        />

        <div className="terms-container" style={{ margin: "10px 0", fontSize: "0.9rem", color: "#fff" }}>
          <input
            name="acceptedTerms"
            type="checkbox"
            id="terms"
            checked={formData.acceptedTerms}
            onChange={handleChange}
          />
          <label htmlFor="terms" style={{ marginLeft: "8px", color: "white" }}>
            I agree to the{" "}
            <Link to="/terms" style={{ color: "#007bff" }}>Terms and Conditions</Link> and{" "}
            <Link to="/privacy" style={{ color: "#007bff" }}>Privacy Policy</Link>
          </label>
        </div>

        <button type="submit" className="signup-button">Sign Up</button>
      </form>

      {message && <p style={{ marginTop: "10px", color: "lightyellow" }}>{message}</p>}

      <p className="login-text">
        Already have an account? <Link to="/admin-login">Log In</Link>
      </p>
    </div>
  );
};

export default SignUp;
